import Icon from '../../components/Icon.vue'

Icon.register({"regular/file":{"width":384,"height":512,"paths":[{"d":"M369.9 97.9L286 14C277 5 264.8-0.1 252.1-0.1H48C21.5 0 0 21.5 0 48V464C0 490.5 21.5 512 48 512H336C362.5 512 384 490.5 384 464V131.9C384 119.2 378.9 106.9 369.9 97.9zM332.1 128H256V51.9L332.1 128zM48 464V48H208V152C208 165.3 218.7 176 232 176H336V464H48z"}]}})



// WEBPACK FOOTER //
// ./node_modules/vue-awesome/icons/regular/file.js